import React, { useEffect, useReducer } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import _ from "lodash";
import tw from "tailwind-styled-components";
import getSymbolFromCurrency from "currency-symbol-map";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { Zoom } from "@mui/material";
import { PrimaryText, TostMessage } from "@components";
import { getSelectedPlayerData, getListingBookings } from "@store";
import rightIcon from "@assets/image/rightIcon.png";
import rightView from "@assets/image/rightView.png";
import "./teeTimeBox.css";

function TeeTimeBox(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const activePlayer = useSelector((state) => state.courses.activePlayer);
  const addToCartData = useSelector((state) => state.bookings?.addToCartData);
  const showPrice = useSelector((state) => state.setting.showPrice);
  const listingBookingData = useSelector(
    (state) => state.bookings?.listingBookingData
  );
  const apiTimer = useSelector((state) => state.setting.time);
  const playerTypeId = apiTimer?.data?.data;

  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      dots: [1, 2, 3, 4],
      availableDots: 0,
      menuModal: null,
      alertMessage: false,
      checkoutLoder: false,
      addToCartLoder: false,
      alertMessageTxt: null,
      players: activePlayer,
      is_RequireTo_Update: true,
    }
  );

  let current_Dots =
    state.dots
      ?.slice(0, 4 - state.availableDots)
      ?.slice(0, props?.teeTimeData?.players) || [];

  useEffect(() => {
    if (listingBookingData?.data?.length) {
      let result = [];
      result = result.concat(
        listingBookingData?.data?.filter((e) => {
          return (
            e?.teetime === props?.teeTimeData?.time &&
            e?.course === props?.teeTimeData?.course &&
            (e?.status === "BOOKED" || e?.status === "CREATED")
          );
        })
      );
      let totalPayers = result.reduce(
        (total, currentValue) => total + currentValue?.players,
        0
      );
      setState({ availableDots: totalPayers });
    }
  }, [listingBookingData, props]);

  useEffect(() => {
    if (props?.isSelect) {
      setState({
        players: props?.isSelect?.selectedPlayer,
      });
    } else {
      setState({
        players: activePlayer,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, addToCartData]);

  const selectPlayer = (e) => {
    setState({ menuModal: e?.currentTarget });
  };

  const checkPastTeeTime = () => {
    let currentTimeFilter = _.filter(addToCartData, function (e) {
      return moment().isSameOrAfter(e?.teeTime?.teeTimeData?.time);
    });
    if (currentTimeFilter?.length) {
      return true;
    } else {
      return false;
    }
  };

  const checkListingBooking = (price, type, is_upDate) => {
    const normalPrice = price?.pricing.find(
      (f) => f?.playerType === playerTypeId?.casualPlayerTypeId
    );

    const golfIrlandPrice = price?.pricing.find(
      (f) => f?.playerType !== playerTypeId?.casualPlayerTypeId
    );

    const actualPrice = showPrice
      ? golfIrlandPrice?.price?.amount < normalPrice?.price?.amount
        ? golfIrlandPrice?.price?.amount
        : normalPrice?.price?.amount
      : normalPrice?.price?.amount;

    let formDate = moment(props?.teeTimeData?.time)
      .subtract(1, "day")
      .format("DD-MM-YYYY");
    let toDate = moment(props?.teeTimeData?.time)
      .add(1, "day")
      .format("DD-MM-YYYY");

    let bookingsApiData = {
      fromDate: formDate,
      toDate: toDate,
    };
    dispatch(getListingBookings(bookingsApiData)).then(async (res) => {
      if (
        (await res?.payload?.data?.data?.data) &&
        (await res?.payload?.status) === 200
      ) {
        let listingData = await res?.payload?.data?.data?.data;
        let result = [];

        result = result.concat(
          listingData?.filter((e) => {
            return (
              e?.teetime === props?.teeTimeData?.time &&
              e?.course === props?.teeTimeData?.course &&
              (e?.status === "BOOKED" || e?.status === "CREATED")
            );
          })
        );
        let totalPayers = result.reduce(
          (total, currentValue) => total + currentValue.players,
          0
        );

        if (
          result?.length &&
          (totalPayers >= 4 || 4 - totalPayers < state.players)
        ) {
          setState({
            alertMessage: true,
            alertMessageTxt:
              "Some players have been booked for this tee time by another user, Please change the number of players and rebook !",
            menuModal: null,
            addToCartLoder: false,
            checkoutLoder: false,
          });
        } else {
          dispatch(
            getSelectedPlayerData({
              props,
              price,
              save: true,
              is_Update: is_upDate,
              isGolfIreland_Rate:
                golfIrlandPrice?.price?.amount < normalPrice?.price?.amount &&
                showPrice,
              selectedPlayer: state.players,
              actualPrice: actualPrice,
            })
          );
          setState({
            menuModal: null,
            addToCartLoder: false,
            checkoutLoder: false,
            alertMessage: false,
            alertMessageTxt: null,
          });
          if (type === "teeTime") {
            if (checkPastTeeTime()) {
              setState({
                alertMessage: true,
                alertMessageTxt:
                  "Please Remove Past Tee Time in your cart before checkout!",
              });
            } else {
              navigate("/check-out");
              window.scrollTo(0, 0);
            }
          }
        }
      } else {
        dispatch(
          getSelectedPlayerData({
            props,
            price,
            save: true,
            is_Update: is_upDate,
            isGolfIreland_Rate:
              golfIrlandPrice?.price?.amount < normalPrice?.price?.amount &&
              showPrice,
            selectedPlayer: state.players,
            actualPrice: actualPrice,
          })
        );
        setState({
          menuModal: null,
          addToCartLoder: false,
          checkoutLoder: false,
        });
        if (type === "teeTime") {
          if (checkPastTeeTime()) {
            setState({
              alertMessage: true,
              alertMessageTxt:
                "Please Remove Past Tee Time in your cart before checkout!",
            });
          } else {
            navigate("/check-out");
            window.scrollTo(0, 0);
          }
        }
      }
    });
  };

  const addToCart = (item) => {
    if (props?.isSelect) {
      if (!state.is_RequireTo_Update) {
        checkListingBooking(item, "cart", "upDate");
        setState({
          menuModal: null,
          is_RequireTo_Update: true,
        });
      } else {
        dispatch(
          getSelectedPlayerData({
            props,
            item,
            save: true,
            isGolfIreland_Rate: showPrice,
            selectedPlayer: state.players,
          })
        );
        setState({
          menuModal: null,
          is_RequireTo_Update: true,
        });
      }
    } else {
      setState({ addToCartLoder: true, is_RequireTo_Update: true });
      checkListingBooking(item, "cart");
    }
  };

  const checkOutPay = (item) => {
    setState({ checkoutLoder: true });
    if (props?.isSelect) {
      checkListingBooking(item, "teeTime", "upDate");
    } else {
      checkListingBooking(item, "teeTime");
    }
  };

  const PlayerBtn = (item) => {
    const selectPlayerPrice = () => {
      setState({
        players: item?.value,
        // is_RequireTo_Update: props?.isSelect
        //   ? item?.value === props?.price?.selectedPlayer
        //   : false,
      });
    };

    return (
      <button
        onClick={selectPlayerPrice}
        className={`${roundBtn} ${
          state.players === item?.value
            ? "bg-primary text-white255 hover:cursor-default"
            : "border text-textColor2 hover:opacity-70 hover:border-primary"
        }`}
      >
        {item?.value}
      </button>
    );
  };

  const PriceView = (e) => {
    const normalPrice = e?.data.find(
      (f) => f?.playerType === playerTypeId?.casualPlayerTypeId
    );

    const golfIrlandPrice = e?.data.find(
      (f) => f?.playerType !== playerTypeId?.casualPlayerTypeId
    );

    const amount = showPrice
      ? golfIrlandPrice?.price?.amount < normalPrice?.price?.amount
        ? golfIrlandPrice?.price?.amount
        : normalPrice?.price?.amount
      : normalPrice?.price?.amount;

    const currency = normalPrice?.price?.currency;

    if (amount === undefined) return null;

    return (
      <span className={`${priceTxt} font-semibold`}>
        {`${getSymbolFromCurrency(currency)}${amount}`}
      </span>
    );
  };

  const GolfIrlandPrice = (e) => {
    const normalPrice = e?.data.find(
      (f) => f?.playerType === playerTypeId?.casualPlayerTypeId
    );

    const golfIrlandPrice = e?.data.find(
      (f) => f?.playerType !== playerTypeId?.casualPlayerTypeId
    );

    return (
      <>
        {golfIrlandPrice?.price?.amount < normalPrice?.price?.amount ? (
          <span className={priceTxt2}>
            {`${getSymbolFromCurrency(normalPrice?.price?.currency)}${
              normalPrice?.price?.amount
            }`}
          </span>
        ) : (
          <></>
        )}{" "}
      </>
    );
  };

  const btnStyle = {
    width: "100%",
    height: "100%",
    borderRadius: "13px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "end",
    lineHeight: 1,
    padding: "0px",
  };

  const SelectedTee = (item) => {
    return (
      <ImgView>
        <img
          src={rightView}
          alt="img"
          style={{
            width: "44px",
            height: "25px",
            marginTop: "-4px",
            marginLeft: "2px",
            borderTopRightRadius: "10px",
          }}
        />
        <img
          src={rightIcon}
          alt="img"
          style={{
            width: "10px",
            height: "10px",
            marginLeft: "25px",
            marginTop: "-20px",
          }}
        />
      </ImgView>
    );
  };

  const SelectedModal = ({ item }) => {
    return (
      <div className="sm:w-[230px] sm2:w-[230px] w-[215px] h-auto mx-4">
        <PlayerView>
          <PrimaryText className={playerTxt}>{t("players")}</PrimaryText>
          <div className="flex flex-row justify-center items-center gap-x-2">
            {current_Dots?.map((item2, index2) => (
              <React.Fragment key={`price${index2}`}>
                <PlayerBtn value={item2} teeTime_Data={props} />
              </React.Fragment>
            ))}
          </div>
        </PlayerView>
        <Line />
        <SelectView>
          <button
            onClick={() => addToCart(item)}
            className={btn}
            disabled={state.addToCartLoder}
          >
            {state.addToCartLoder ? (
              <CircularProgress
                sx={{ color: "#ffffff" }}
                size={20}
                thickness={5}
              />
            ) : (
              <span className={txt}>
                {" "}
                {/* {props?.isSelect
                  ? !state.is_RequireTo_Update
                    ? "Update Cart"
                    : `${t("removeCart")}`
                  : `${t("addCart")}`} */}
                {props?.isSelect ? `${t("removeCart")}` : `${t("addCart")}`}
              </span>
            )}
          </button>
          <button
            onClick={() => checkOutPay(item)}
            className={btn}
            disabled={state.checkoutLoder}
          >
            {state.checkoutLoder ? (
              <CircularProgress
                sx={{ color: "#ffffff" }}
                size={20}
                thickness={5}
              />
            ) : (
              <span className={txt}>
                {" "}
                {props?.isSelect ? `${t("checkout")}` : `${t("addCheckout")}`}
              </span>
            )}
          </button>
        </SelectView>
      </div>
    );
  };

  // console.log('*** playerTypeId?.casualPlayerTypeId ', playerTypeId?.casualPlayerTypeId)
  // console.log('*** props?.teeTimeData?.pricing ', props?.teeTimeData?.pricing)

  return (
    <>
      {
        current_Dots?.length >= activePlayer &&
          props?.teeTimeData?.pricing?.length > 1 && (
            // props?.teeTimeData?.pricing?.map((item, index) => (
            <React.Fragment>
              {
                // item?.players === activePlayer &&
                <>
                  <Box
                    className={`${
                      state.menuModal
                        ? "cursor-pointer border-primary bg-white255a"
                        : ""
                    }`}
                  >
                    <Button onClick={(e) => selectPlayer(e)} sx={btnStyle}>
                      <div
                        className={`w-full h-[31px] flex bg-[white] rounded-lg justify-center border-[2px] border-white items-end pb-[1px] absolute top-[-4px]`}
                      >
                        <span className={timeTxt}>
                          {moment(props?.teeTimeData?.time).format("HH:mm")}
                        </span>
                      </div>

                      <div className="w-full h-[60%] flex flex-col justify-around items-center">
                        <div className="w-auto h-full flex flex-row justify-between items-center gap-x-[7px]">
                          {showPrice ? (
                            <GolfIrlandPrice
                              data={props?.teeTimeData?.pricing}
                            />
                          ) : (
                            <></>
                          )}
                          <PriceView data={props?.teeTimeData?.pricing} />
                        </div>
                        {props?.isSelect && <SelectedTee />}
                        <DoteView>
                          {current_Dots?.map((d, index2) => (
                            <React.Fragment key={`teeTime${index2}`}>
                              <Dot />
                            </React.Fragment>
                          ))}
                          {/* {Array.from(
                          { length: props?.teeTimeData?.players },
                          (_, i) => i + 1
                        )?.map((d, index2) => (
                          <React.Fragment key={`teeTime${index2}`}>
                            <Dot />
                          </React.Fragment>
                        ))} */}
                        </DoteView>
                      </div>
                    </Button>
                  </Box>
                  <Menu
                    anchorEl={state.menuModal}
                    open={Boolean(state.menuModal)}
                    onClose={() => setState({ menuModal: null })}
                    TransitionComponent={Zoom}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 4px rgba(0,0,0,0.32))",
                        borderRadius: "14px",
                        mt: 1,
                      },
                    }}
                    transformOrigin={{ horizontal: "center", vertical: "top" }}
                    anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
                  >
                    <SelectedModal item={props?.teeTimeData} />{" "}
                  </Menu>
                </>
              }
            </React.Fragment>
          )
        // ))
      }
      {state.alertMessageTxt && (
        <TostMessage
          open={state.alertMessage}
          onClose={() =>
            setState({
              alertMessage: false,
              alertMessageTxt: null,
            })
          }
          title={state.alertMessageTxt}
          type={"info"}
        />
      )}
    </>
  );
}

const Box = tw.div`
flex
flex-row
items-center
justify-end
hover:cursor-pointer
bg-primary
border-[1px]
border-[white]
h-[77px]
w-[97px]
rounded-xl
hover:border-black
hover:bg-[#e2cda8]
`;

const Dot = tw.div`
w-[5px] 
h-[5px] 
bg-[white]
rounded-full
mt-[3px]
`;
const priceTxt = `
text-[21px]
font-[Cambay] 
text-[white]
`;
const priceTxt2 = `
text-[14px]
font-[Cambay] 
text-[white]
line-through
decoration-[white]
opacity-80
tracking-tight
`;

const timeTxt = `
text-[21px]
font-medium
font-[Cambay] 
text-primary
`;
const roundBtn = `
w-8 
h-8 
rounded-full 
flex 
items-center 
justify-center
border-[#828282]
`;
const ImgView = tw.div`
w-[39px] 
h-[20px] 
absolute 
top-0 
right-0 
rounded-tr-[10px]
`;
const DoteView = tw.div`
h-auto 
w-full
flex 
flex-row 
items-center 
justify-center
overflow-hidden
gap-x-[5px]
pb-[5px]
`;
const PlayerView = tw.div`
w-full 
h-auto 
flex 
flex-row 
items-center 
justify-center
gap-x-[4px]
`;
const Line = tw.div`
w-full
h-[1.1px] 
bg-[#C5C5C5] 
mt-4
`;
const SelectView = tw.div`
w-full 
h-auto 
flex 
flex-col 
items-center 
justify-between 
mt-[12px]
mb-[5px]
gap-y-2
`;
const playerTxt = `
text-md
font-semibold 
font-[Cambay] 
text-center 
text-textColor2
`;
const btn = `
w-full 
h-auto 
rounded-full 
text-center 
px-[5px]
py-[5px] 

bg-primary
hover:bg-primary2
`;
const txt = `
font-medium 
text-sm 
font-[Cambay] 
text-center 
text-white255
uppercase
truncate
`;

export default TeeTimeBox;
